import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import { initializeAnalytics, trackPage } from 'services/analytics/analytics';
import { history } from 'store/history';

import { Root } from './components/Root/Root';

try {
  // Initialize tracking + page change listening
  initializeAnalytics();
  history.listen(trackPage);

  // track current page
  trackPage();

  if (process.env.NODE_ENV === 'development') {
    // tslint:disable-next-line no-var-requires
    const axe = require('@axe-core/react');
    axe(React, ReactDOM, 1000);
  }

  // Always try to render
  const container = document.getElementById('root');
  if (!container) {
    throw new Error('Could not find root element');
  }
  const root = createRoot(container);
  root.render(<Root />);
} catch (e) {
  window.console.error('bootstrap error:', e);
}
